// extracted by mini-css-extract-plugin
module.exports = {"root":"Loading_root__zFeB7","skeleton":"Loading_skeleton___dItF","card":"Loading_card__JhNql"};